import React from 'react';
import { SFPalette } from '@/lib/color';
import Typography from '@mui/material/Typography';
import Box, { BoxProps } from '@mui/material/Box';

export default function BulletList({ list, sx, ...props }: { list: string[] } & BoxProps) {
  return (
    <Box
      component="ul"
      {...props}
      sx={{
        pl: 0, // This sets the left padding
        '& li::marker': {
          color: SFPalette.lightGrey2, // This sets the color of the bullets
          fontSize: '0.4rem',
        },
        my: 0,
        ...sx,
      }}
    >
      {list.map((text, idx) => (
        <li key={idx}>
          <Typography variant="body2" color={SFPalette.grey4}>
            {text}
          </Typography>
        </li>
      ))}
    </Box>
  );
}
